module.exports = __webpack_public_path__ + "img/5.c63ae628.png";